/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatUserCreateRequest
 */
export interface ChatUserCreateRequest {
    /**
     * Display name of the chat agent
     * @type {string}
     * @memberof ChatUserCreateRequest
     */
    name: string;
    /**
     * URL of the agent's avatar image
     * @type {string}
     * @memberof ChatUserCreateRequest
     */
    avatarUrl: string;
}

/**
 * Check if a given object implements the ChatUserCreateRequest interface.
 */
export function instanceOfChatUserCreateRequest(value: object): value is ChatUserCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    return true;
}

export function ChatUserCreateRequestFromJSON(json: any): ChatUserCreateRequest {
    return ChatUserCreateRequestFromJSONTyped(json, false);
}

export function ChatUserCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatUserCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'avatarUrl': json['avatarUrl'],
    };
}

export function ChatUserCreateRequestToJSON(json: any): ChatUserCreateRequest {
    return ChatUserCreateRequestToJSONTyped(json, false);
}

export function ChatUserCreateRequestToJSONTyped(value?: ChatUserCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'avatarUrl': value['avatarUrl'],
    };
}

